import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import { Provider } from 'react-redux';
import store from '../../../redux-modules/store';
import HitWithWishlist from './HitWithWishlist';

export default function Hit({ results, hit, additionalData }: componentTypes.HitProps) {
  return (
    <Provider store={store}>
      <HitWithWishlist
        results={results}
        hit={hit}
        additionalData={additionalData}
      />
    </Provider>
  );
}
